
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Model3() {
    const [activeModal, setActiveModal] = useState(null); // 'subsidy', 'tracker', 'crop', 'support', 'cropDetail'
    const [selectedCrop, setSelectedCrop] = useState(null);
    const [trackerId, setTrackerId] = useState("");
    const [trackerResult, setTrackerResult] = useState(null);
    const [toastMessage, setToastMessage] = useState("");

    // Form states
    const [formData, setFormData] = useState({ name: "", phone: "", district: "", cropType: "", acres: "" });
    const [contactData, setContactData] = useState({ name: "", email: "", message: "" });

    const primaryColor = "#064E3B"; // Deep Emerald Green
    const accentColor = "#D97706";  // Warm Gold / Amber
    const sageBg = "#F0FDF4";       // Soft Light Green

    useEffect(() => {
        // Inject Bootstrap CSS
        if (!document.getElementById("bootstrap-css")) {
            const linkBootstrap = document.createElement("link");
            linkBootstrap.id = "bootstrap-css";
            linkBootstrap.rel = "stylesheet";
            linkBootstrap.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
            document.head.appendChild(linkBootstrap);
        }
        // Inject Bootstrap Icons CSS
        if (!document.getElementById("bootstrap-icons")) {
            const linkIcons = document.createElement("link");
            linkIcons.id = "bootstrap-icons";
            linkIcons.rel = "stylesheet";
            linkIcons.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
            document.head.appendChild(linkIcons);
        }
        // Inject Bootstrap JS Bundle
        if (!document.getElementById("bootstrap-js")) {
            const scriptBootstrap = document.createElement("script");
            scriptBootstrap.id = "bootstrap-js";
            scriptBootstrap.src = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js";
            document.body.appendChild(scriptBootstrap);
        }
    }, []);

    const services = [
        { id: "subsidy", icon: "bi-file-earmark-check-fill", title: "Apply for Subsidy", desc: "Access direct farmer benefits & greenhouse grants" },
        { id: "tracker", icon: "bi-search", title: "Track Application", desc: "Check status of your submitted schemes instantly" },
        { id: "crop", icon: "bi-flower2", title: "Crop Information", desc: "Explore high-yield varieties & seasonal advisory" },
        { id: "support", icon: "bi-headset", title: "Farmer Helpline", desc: "Connect directly with district horticulture officers" },
    ];

    const schemes = [
        {
            id: 1,
            title: "Mission for Integrated Development of Horticulture",
            desc: "Comprehensive support for production, post-harvest management, and organic farming.",
            image: "https://images.unsplash.com/photo-1499529112087-3cb3b73cec95?auto=format&fit=crop&w=800&q=85",
            badge: "Flagship Scheme",
            subsidy: "Up to 50% Subsidy"
        },
        {
            id: 2,
            title: "Protected Cultivation & Greenhouse Subsidy",
            desc: "Financial assistance for polyhouses, shade nets, and micro-irrigation equipment.",
            image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=800&q=85",
            badge: "High Tech",
            subsidy: "Up to 75% Support"
        },
        {
            id: 3,
            title: "Precision Farming & Drip Irrigation",
            desc: "Optimize water usage with automated drip systems and fertigation kits.",
            image: "https://images.unsplash.com/photo-1560493676-04071c5f467b?auto=format&fit=crop&w=800&q=85",
            badge: "Water Saving",
            subsidy: "Subsidy + Free Setup"
        },
    ];

    const crops = [
        { name: "Exotic Fruits", desc: "Dragon fruit, avocado, mango & high-density orchards", image: "https://images.unsplash.com/photo-1619566636858-adf3ef46400b?auto=format&fit=crop&w=700&q=85", season: "All Season", yield: "High ROI" },
        { name: "Organic Vegetables", desc: "Tomato, bell pepper, exotic greens in controlled environments", image: "https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=700&q=85", season: "Rabi & Kharif", yield: "Fast Harvest" },
        { name: "Floriculture", desc: "Gerbera, rose, carnation & loose flower commercial cultivation", image: "https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&w=700&q=85", season: "Year-Round", yield: "High Export Value" },
        { name: "Plantation Crops", desc: "Spices, medicinal plants, coconut & cocoa farming", image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=700&q=85", season: "Perennial", yield: "Steady Income" },
    ];

    const handleServiceClick = (id) => {
        setActiveModal(id);
    };

    const handleSubsidySubmit = (e) => {
        e.preventDefault();
        if (!formData.name || !formData.phone || !formData.district) {
            setToastMessage("Please fill in all required fields.");
            return;
        }
        const randomAppId = "TN-HORT-" + Math.floor(100000 + Math.random() * 900000);
        setToastMessage(`Application submitted successfully! Your Application ID is ${randomAppId}`);
        setFormData({ name: "", phone: "", district: "", cropType: "", acres: "" });
        setTimeout(() => setActiveModal(null), 3000);
    };

    const handleTrackSubmit = (e) => {
        e.preventDefault();
        if (!trackerId.trim()) return;
        setTrackerResult({
            id: trackerId.toUpperCase(),
            status: "Verified & Under District Officer Review",
            date: "2026-03-10",
            scheme: "Protected Cultivation Subsidy"
        });
    };

    const handleContactSubmit = (e) => {
        e.preventDefault();
        setToastMessage("Thank you! Your message has been sent to the Department Support team.");
        setContactData({ name: "", email: "", message: "" });
    };

    const [selectedTheme, setSelectedTheme] = useState("theme5");

    const navigate = useNavigate();

    const handleThemeChange = (value) => {
        setSelectedTheme(value);

        if (value === "theme4") {
            navigate("/model2");
        } else if (value === "theme5") {
            navigate("/model3");
        } else {
            navigate("/");
        }
    };

    return (
        <div style={{ backgroundColor: "#F9FAFB", color: "#1F2937", fontFamily: "system-ui, -apple-system, sans-serif", minHeight: "100vh" }}>

            {/* Toast Notification Banner */}
            {toastMessage && (
                <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 1100 }}>
                    <div className="toast show align-items-center text-white border-0 shadow-lg" style={{ backgroundColor: primaryColor }} role="alert">
                        <div className="d-flex">
                            <div className="toast-body py-3 px-4">
                                <i className="bi bi-info-circle-fill me-2" style={{ color: accentColor }}></i>
                                {toastMessage}
                            </div>
                            <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setToastMessage("")}></button>
                        </div>
                    </div>
                </div>
            )}

            <div className="text-white py-2">
                <div className="container d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <span className="small">
                        🇮🇳 Government of Tamil Nadu
                    </span>

                    <div className="d-flex align-items-center gap-3">
                      
                        <select
                            className="form-select form-select-sm"
                            aria-label="Select theme"
                            style={{ width: 120 }}
                            value={selectedTheme}
                            onChange={(e) => handleThemeChange(e.target.value)}
                        >
                            <option value="theme1">Theme 1</option>
                            <option value="theme2">Theme 2</option>
                            <option value="theme3">Theme 3</option>
                            <option value="theme4">Theme 4</option>
                            <option value="theme5">Theme 5</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* Navigation Bar */}
            <nav className="navbar navbar-expand-lg sticky-top shadow-sm py-3" style={{ backgroundColor: "#FFFFFF" }}>
                <div className="container">
                    <a className="navbar-brand d-flex align-items-center gap-3 text-decoration-none" href="#home">
                        <div className="rounded-circle p-2 d-flex align-items-center justify-content-center text-white shadow-sm" style={{ width: "48px", height: "48px", backgroundColor: primaryColor }}>
                            <i className="bi bi-flower1 fs-4" style={{ color: accentColor }}></i>
                        </div>
                        <div>
                            <span className="fw-bold fs-5 d-block" style={{ color: primaryColor, letterSpacing: "-0.5px" }}>HORTI-CONNECT</span>
                            <span className="text-muted" style={{ fontSize: "0.75rem", letterSpacing: "1px" }}>DEPARTMENT OF HORTICULTURE</span>
                        </div>
                    </a>

                    <button className="navbar-toggler border-0 shadow-none" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="mainNavbar">
                        <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-3 my-3 my-lg-0">
                            <li className="nav-item"><a className="nav-link fw-semibold text-dark" href="#home">Home</a></li>
                            <li className="nav-item"><a className="nav-link fw-semibold text-dark" href="#services">Services</a></li>
                            <li className="nav-item"><a className="nav-link fw-semibold text-dark" href="#schemes">Schemes</a></li>
                            <li className="nav-item"><a className="nav-link fw-semibold text-dark" href="#crops">Crops</a></li>
                            <li className="nav-item"><a className="nav-link fw-semibold text-dark" href="#contact">Contact</a></li>
                            <li className="nav-item ms-lg-2">
                                <button
                                    onClick={() => handleServiceClick('subsidy')}
                                    className="btn text-white fw-bold px-4 py-2 rounded-pill shadow-sm"
                                    style={{ backgroundColor: accentColor }}
                                >
                                    Apply Subsidy <i className="bi bi-arrow-right ms-1"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <section id="home" className="position-relative text-white py-5 overflow-hidden" style={{ backgroundColor: primaryColor, minHeight: "85vh", display: "flex", alignItems: "center" }}>
                <div className="position-absolute top-0 start-0 w-100 h-100 opacity-25" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1800&q=85')`, backgroundSize: "cover", backgroundPosition: "center" }}></div>
                <div className="container position-relative py-5">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-7">
                            <span className="badge px-3 py-2 rounded-pill mb-4 fw-semibold shadow-sm" style={{ backgroundColor: "rgba(217, 119, 6, 0.2)", color: accentColor, border: `1px solid ${accentColor}` }}>
                                <i className="bi bi-stars me-2"></i> GOVERNMENT FARMER EMPOWERMENT PORTAL
                            </span>
                            <h1 className="display-3 fw-extrabold lh-sm mb-4">
                                Growing Prosperity Through <span style={{ color: accentColor }}>Modern Horticulture</span>
                            </h1>
                            <p className="fs-5 text-white-50 mb-5 lh-base" style={{ maxWidth: "620px" }}>
                                Access state-backed agricultural subsidies, high-yield crop guides, precision farming assistance, and direct officer support online.
                            </p>
                            <div className="d-flex flex-wrap gap-3">
                                <button onClick={() => handleServiceClick('subsidy')} className="btn btn-lg fw-bold px-4 py-3 rounded-pill shadow" style={{ backgroundColor: accentColor, color: "#fff" }}>
                                    <i className="bi bi-file-earmark-plus me-2"></i> Apply for Subsidy
                                </button>
                                <button onClick={() => handleServiceClick('tracker')} className="btn btn-lg btn-outline-light fw-bold px-4 py-3 rounded-pill">
                                    <i className="bi bi-search me-2"></i> Track Application
                                </button>
                            </div>

                            <div className="row mt-5 pt-4 border-top border-light border-opacity-10 g-4">
                                <div className="col-4">
                                    <h3 className="fw-bold mb-0 text-white" style={{ color: accentColor }}>25+</h3>
                                    <small className="text-white-50">Active Schemes</small>
                                </div>
                                <div className="col-4">
                                    <h3 className="fw-bold mb-0 text-white" style={{ color: accentColor }}>₹120Cr+</h3>
                                    <small className="text-white-50">Subsidies Disbursed</small>
                                </div>
                                <div className="col-4">
                                    <h3 className="fw-bold mb-0 text-white" style={{ color: accentColor }}>1.5L+</h3>
                                    <small className="text-white-50">Farmers Benefited</small>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5">
                            <div className="card border-0 shadow-lg p-4 rounded-4 text-dark" style={{ backgroundColor: "rgba(255, 255, 255, 0.95)", backdropFilter: "blur(10px)" }}>
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-4 gap-3">
                                        <div className="rounded-circle p-3 text-white" style={{ backgroundColor: primaryColor }}>
                                            <i className="bi bi-bell-fill fs-4" style={{ color: accentColor }}></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-0" style={{ color: primaryColor }}>Latest Announcements</h5>
                                            <small className="text-muted">Updated Today</small>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column gap-3">
                                        <div className="p-3 rounded-3 border-start border-4 shadow-sm" style={{ backgroundColor: sageBg, borderColor: primaryColor }}>
                                            <span className="badge bg-success mb-1">New</span>
                                            <h6 className="fw-bold mb-1" style={{ color: primaryColor }}>Protected Cultivation Grants 2026</h6>
                                            <p className="small text-muted mb-0">Polyhouse and shade-net installation subsidies increased by 15% for small farmers.</p>
                                        </div>
                                        <div className="p-3 rounded-3 border-start border-4 shadow-sm bg-light" style={{ borderColor: accentColor }}>
                                            <span className="badge bg-warning text-dark mb-1">Advisory</span>
                                            <h6 className="fw-bold mb-1" style={{ color: primaryColor }}>Drip Irrigation Maintenance</h6>
                                            <p className="small text-muted mb-0">Free technical camp scheduled across all district headquarters this weekend.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section id="services" className="container py-5 my-4">
                <div className="text-center mb-5">
                    <span className="text-uppercase fw-bold tracking-wide small" style={{ color: accentColor }}>QUICK ACCESS PORTAL</span>
                    <h2 className="display-5 fw-bold mt-2" style={{ color: primaryColor }}>Essential Farmer Services</h2>
                    <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>Select a service below to get started instantly with your digital horticulture request.</p>
                </div>

                <div className="row g-4">
                    {services.map((srv) => (
                        <div className="col-md-6 col-lg-3" key={srv.id}>
                            <div
                                onClick={() => handleServiceClick(srv.id)}
                                className="card border-0 shadow-sm h-100 p-4 rounded-4 text-center text-decoration-none cursor-pointer"
                                style={{ backgroundColor: "#FFFFFF", cursor: "pointer", transition: "transform 0.2s ease, box-shadow 0.2s ease" }}
                                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 1rem 3rem rgba(0,0,0,.1)"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 .125rem .25rem rgba(0,0,0,.075)"; }}
                            >
                                <div className="card-body d-flex flex-column align-items-center">
                                    <div className="rounded-circle p-4 mb-3 d-flex align-items-center justify-content-center shadow-sm" style={{ backgroundColor: sageBg, color: primaryColor, width: "75px", height: "75px" }}>
                                        <i className={`bi ${srv.icon} fs-2`}></i>
                                    </div>
                                    <h4 className="fw-bold fs-5 mb-2" style={{ color: primaryColor }}>{srv.title}</h4>
                                    <p className="text-muted small mb-4">{srv.desc}</p>
                                    <span className="mt-auto fw-bold small d-inline-flex align-items-center gap-1" style={{ color: accentColor }}>
                                        Access Service <i className="bi bi-arrow-right"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Schemes Section */}
            <section id="schemes" className="py-5" style={{ backgroundColor: sageBg }}>
                <div className="container py-4">
                    <div className="row align-items-end mb-5">
                        <div className="col-lg-8">
                            <span className="text-uppercase fw-bold tracking-wide small" style={{ color: accentColor }}>GOVERNMENT SUPPORT</span>
                            <h2 className="display-5 fw-bold mt-2" style={{ color: primaryColor }}>Featured Horticultural Schemes</h2>
                            <p className="text-muted mb-0">Explore specialized financial assistance programs tailored for progressive cultivators.</p>
                        </div>
                        <div className="col-lg-4 text-lg-end mt-3 mt-lg-0">
                            <button onClick={() => handleServiceClick('subsidy')} className="btn btn-outline-dark rounded-pill px-4 py-2 fw-semibold">
                                View All Schemes <i className="bi bi-grid-fill ms-1"></i>
                            </button>
                        </div>
                    </div>

                    <div className="row g-4">
                        {schemes.map((sch) => (
                            <div className="col-md-6 col-lg-4" key={sch.id}>
                                <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 bg-white">
                                    <div className="position-relative">
                                        <img src={sch.image} alt={sch.title} className="w-100" style={{ height: "220px", objectFit: "cover" }} />
                                        <span className="position-absolute top-0 start-0 m-3 badge px-3 py-2 rounded-pill fw-semibold shadow-sm text-white" style={{ backgroundColor: accentColor }}>
                                            {sch.badge}
                                        </span>
                                        <span className="position-absolute bottom-0 end-0 m-3 badge bg-dark px-3 py-2 rounded-pill opacity-75">
                                            {sch.subsidy}
                                        </span>
                                    </div>
                                    <div className="card-body p-4 d-flex flex-column">
                                        <h4 className="fw-bold fs-5 mb-3" style={{ color: primaryColor }}>{sch.title}</h4>
                                        <p className="text-muted small mb-4 flex-grow-1">{sch.desc}</p>
                                        <button onClick={() => handleServiceClick('subsidy')} className="btn btn-outline-success w-100 rounded-pill fw-semibold">
                                            Apply For This Scheme <i className="bi bi-chevron-right ms-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Crops Section */}
            <section id="crops" className="container py-5 my-4">
                <div className="text-center mb-5">
                    <span className="text-uppercase fw-bold tracking-wide small" style={{ color: accentColor }}>KNOWLEDGE REPOSITORY</span>
                    <h2 className="display-5 fw-bold mt-2" style={{ color: primaryColor }}>Explore Horticulture Crops</h2>
                    <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>Click on any crop category to view detailed cultivation advisory, seasonal timelines, and best practices.</p>
                </div>

                <div className="row g-4">
                    {crops.map((crop, idx) => (
                        <div className="col-sm-6 col-lg-3" key={idx}>
                            <div
                                onClick={() => { setSelectedCrop(crop); setActiveModal('cropDetail'); }}
                                className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 text-decoration-none cursor-pointer position-relative"
                                style={{ cursor: "pointer" }}
                            >
                                <img src={crop.image} alt={crop.name} className="w-100" style={{ height: "200px", objectFit: "cover" }} />
                                <div className="card-body p-4 d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <span className="badge bg-light text-dark">{crop.season}</span>
                                        <span className="badge" style={{ backgroundColor: sageBg, color: primaryColor }}>{crop.yield}</span>
                                    </div>
                                    <h4 className="fw-bold fs-5 mb-2" style={{ color: primaryColor }}>{crop.name}</h4>
                                    <p className="text-muted small mb-3">{crop.desc}</p>
                                    <span className="mt-auto fw-bold small text-success d-flex align-items-center gap-1">
                                        View Advisory <i className="bi bi-arrow-up-right"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Contact Section */}
            <section id="contact" className="py-5 text-white" style={{ backgroundColor: primaryColor }}>
                <div className="container py-4">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <span className="badge px-3 py-2 rounded-pill mb-3 fw-semibold" style={{ backgroundColor: "rgba(255,255,255,0.1)", color: accentColor }}>
                                GET IN TOUCH
                            </span>
                            <h2 className="display-5 fw-bold mb-3">Have Questions About Subsidies or Crops?</h2>
                            <p className="text-white-50 mb-4">Our dedicated team of district horticulture officers is ready to assist you with technical guidance and application support.</p>

                            <div className="d-flex flex-column gap-3">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="rounded-circle p-3 text-white" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
                                        <i className="bi bi-geo-alt-fill fs-5" style={{ color: accentColor }}></i>
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-0">State Directorate of Horticulture</h6>
                                        <small className="text-white-50">Agricultural Complex, Anna Nagar, State HQ</small>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                    <div className="rounded-circle p-3 text-white" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
                                        <i className="bi bi-telephone-fill fs-5" style={{ color: accentColor }}></i>
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-0">Farmer Toll-Free Helpline</h6>
                                        <small className="text-white-50">1800-425-HORT (Mon-Sat, 9AM - 6PM)</small>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                    <div className="rounded-circle p-3 text-white" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
                                        <i className="bi bi-envelope-fill fs-5" style={{ color: accentColor }}></i>
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-0">Official Email Support</h6>
                                        <small className="text-white-50">support@horticonnect.gov.in</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="card border-0 shadow-lg p-4 rounded-4 bg-white text-dark">
                                <div className="card-body">
                                    <h4 className="fw-bold mb-4" style={{ color: primaryColor }}>Send Inquiry to Officer</h4>
                                    <form onSubmit={handleContactSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label small fw-semibold">Your Full Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e.g. Ramanathan K"
                                                value={contactData.name}
                                                onChange={(e) => setContactData({ ...contactData, name: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label small fw-semibold">Email Address or Phone</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="farmer@example.com"
                                                value={contactData.email}
                                                onChange={(e) => setContactData({ ...contactData, email: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label small fw-semibold">Your Message / Query</label>
                                            <textarea
                                                className="form-control"
                                                rows="4"
                                                placeholder="Ask about polyhouse subsidies, crop advisory..."
                                                value={contactData.message}
                                                onChange={(e) => setContactData({ ...contactData, message: e.target.value })}
                                                required
                                            ></textarea>
                                        </div>
                                        <button type="submit" className="btn w-100 py-3 fw-bold text-white rounded-pill shadow-sm" style={{ backgroundColor: primaryColor }}>
                                            Submit Inquiry <i className="bi bi-send ms-2"></i>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="py-4 text-white text-center" style={{ backgroundColor: "#022C22" }}>
                <div className="container">
                    <p className="mb-1 small text-white-50">© {new Date().getFullYear()} Directorate of Horticulture & Plantation Crops. Government Initiative.</p>
                    <small className="text-white-50">Designed for Farmer Empowerment, Transparency & Digital Governance.</small>
                </div>
            </footer>

            {/* ================= MODALS ================= */}

            {/* 1. Subsidy Application Modal */}
            {activeModal === 'subsidy' && (
                <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content border-0 rounded-4 shadow-lg">
                            <div className="modal-header text-white px-4 py-3" style={{ backgroundColor: primaryColor }}>
                                <h5 className="modal-title fw-bold"><i className="bi bi-file-earmark-check me-2" style={{ color: accentColor }}></i>Apply for Horticulture Subsidy</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setActiveModal(null)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <form onSubmit={handleSubsidySubmit}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label small fw-semibold">Farmer Full Name *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.name}
                                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                placeholder="Enter full name"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small fw-semibold">Mobile Number *</label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                value={formData.phone}
                                                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                                placeholder="10-digit mobile number"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small fw-semibold">District *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.district}
                                                onChange={(e) => setFormData({ ...formData, district: e.target.value })}
                                                placeholder="e.g. Madurai / Salem"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small fw-semibold">Select Scheme / Crop Type</label>
                                            <select
                                                className="form-select"
                                                value={formData.cropType}
                                                onChange={(e) => setFormData({ ...formData, cropType: e.target.value })}
                                            >
                                                <option value="">Choose program...</option>
                                                <option value="Protected Cultivation">Protected Cultivation (Polyhouse)</option>
                                                <option value="Drip Irrigation">Smart Drip Irrigation Subsidy</option>
                                                <option value="Horticulture Development">General Horticulture Mission</option>
                                                <option value="Organic Farming">Organic Inputs Support</option>
                                            </select>
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label small fw-semibold">Cultivation Area (Acres)</label>
                                            <input
                                                type="number"
                                                step="0.1"
                                                className="form-control"
                                                value={formData.acres}
                                                onChange={(e) => setFormData({ ...formData, acres: e.target.value })}
                                                placeholder="e.g. 2.5"
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-4 d-flex justify-content-end gap-2">
                                        <button type="button" className="btn btn-light rounded-pill px-4" onClick={() => setActiveModal(null)}>Cancel</button>
                                        <button type="submit" className="btn text-white fw-bold rounded-pill px-4" style={{ backgroundColor: accentColor }}>Submit Application</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 2. Application Status Tracker Modal */}
            {activeModal === 'tracker' && (
                <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 rounded-4 shadow-lg">
                            <div className="modal-header text-white px-4 py-3" style={{ backgroundColor: primaryColor }}>
                                <h5 className="modal-title fw-bold"><i className="bi bi-search me-2" style={{ color: accentColor }}></i>Track Application Status</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setActiveModal(null)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <form onSubmit={handleTrackSubmit}>
                                    <label className="form-label small fw-semibold">Enter Application Reference ID</label>
                                    <div className="input-group mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="e.g. TN-HORT-482910"
                                            value={trackerId}
                                            onChange={(e) => setTrackerId(e.target.value)}
                                            required
                                        />
                                        <button className="btn text-white fw-bold" style={{ backgroundColor: accentColor }} type="submit">Search</button>
                                    </div>
                                </form>

                                {trackerResult && (
                                    <div className="p-3 rounded-3 mt-3 border" style={{ backgroundColor: sageBg }}>
                                        <h6 className="fw-bold mb-2" style={{ color: primaryColor }}>Application: {trackerResult.id}</h6>
                                        <p className="small mb-1"><strong>Scheme:</strong> {trackerResult.scheme}</p>
                                        <p className="small mb-1"><strong>Date Filed:</strong> {trackerResult.date}</p>
                                        <p className="small mb-0"><strong>Current Status:</strong> <span className="badge bg-success">{trackerResult.status}</span></p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 3. Crop Detail Modal */}
            {activeModal === 'cropDetail' && selectedCrop && (
                <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content border-0 rounded-4 shadow-lg overflow-hidden">
                            <div className="position-relative">
                                <img src={selectedCrop.image} alt={selectedCrop.name} className="w-100" style={{ height: "250px", objectFit: "cover" }} />
                                <button type="button" className="btn-close btn-close-white position-absolute top-0 end-0 m-3 bg-dark p-2 rounded-circle" onClick={() => setActiveModal(null)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <span className="badge bg-success">{selectedCrop.season}</span>
                                    <span className="badge text-dark" style={{ backgroundColor: accentColor }}>{selectedCrop.yield}</span>
                                </div>
                                <h3 className="fw-bold mb-3" style={{ color: primaryColor }}>{selectedCrop.name}</h3>
                                <p className="text-muted mb-4">{selectedCrop.desc}</p>

                                <h6 className="fw-bold" style={{ color: primaryColor }}>Horticulture Advisory & Best Practices:</h6>
                                <ul className="text-muted small mb-4">
                                    <li>Soil testing recommended before bed preparation.</li>
                                    <li>Recommended drip irrigation frequency: 45 minutes daily during peak summer.</li>
                                    <li>Avail government subsidy on certified seeds and organic pest control kits.</li>
                                </ul>

                                <div className="d-flex justify-content-end">
                                    <button onClick={() => { setActiveModal('subsidy'); }} className="btn text-white fw-bold rounded-pill px-4" style={{ backgroundColor: primaryColor }}>
                                        Apply for Crop Subsidy <i className="bi bi-arrow-right ms-1"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 4. Crop Information Quick Modal from Grid */}
            {activeModal === 'crop' && (
                <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content border-0 rounded-4 shadow-lg">
                            <div className="modal-header text-white px-4 py-3" style={{ backgroundColor: primaryColor }}>
                                <h5 className="modal-title fw-bold"><i className="bi bi-flower2 me-2" style={{ color: accentColor }}></i>Crop Information & Advisory</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setActiveModal(null)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <p className="text-muted">Select a crop category from the main page to read detailed guides, or browse our seasonal handbook below.</p>
                                <div className="row g-3">
                                    {crops.map((c, i) => (
                                        <div className="col-md-6" key={i}>
                                            <div className="p-3 border rounded-3 d-flex align-items-center gap-3">
                                                <img src={c.image} alt={c.name} className="rounded-3" style={{ width: "60px", height: "60px", objectFit: "cover" }} />
                                                <div>
                                                    <h6 className="fw-bold mb-1" style={{ color: primaryColor }}>{c.name}</h6>
                                                    <small className="text-muted">{c.season} • {c.yield}</small>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 5. Support Helpline Modal */}
            {activeModal === 'support' && (
                <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 rounded-4 shadow-lg">
                            <div className="modal-header text-white px-4 py-3" style={{ backgroundColor: primaryColor }}>
                                <h5 className="modal-title fw-bold"><i className="bi bi-headset me-2" style={{ color: accentColor }}></i>Farmer Support & Helpline</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setActiveModal(null)}></button>
                            </div>
                            <div className="modal-body p-4 text-center">
                                <div className="rounded-circle p-4 d-inline-flex mb-3" style={{ backgroundColor: sageBg, color: primaryColor }}>
                                    <i className="bi bi-telephone-inbound fs-1"></i>
                                </div>
                                <h4 className="fw-bold mb-2" style={{ color: primaryColor }}>Call Center Assistance</h4>
                                <p className="text-muted small mb-4">Our officers are available to answer queries regarding crop schemes, fertilizer subsidies, and district camps.</p>
                                <a href="tel:18004254678" className="btn btn-lg text-white fw-bold px-5 rounded-pill shadow-sm mb-3" style={{ backgroundColor: accentColor }}>
                                    <i className="bi bi-telephone-fill me-2"></i> 1800-425-HORT
                                </a>
                                <p className="text-muted small mb-0">Toll-free across all districts. Timing: 9:00 AM - 6:00 PM.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}